import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import { useLocation } from 'react-router-dom'

export default function AdminLayout({ children }) {
  const location = useLocation()
  const selected = location.pathname?.split('/')[2]
  return (
    <div className="min-h-screen bg-background flex">
      <AdminSidebar selected={selected} />
      <div className="flex-1 flex flex-col">
        <AdminHeader selected={selected} />
        <div className="p-8 flex-1">{children}</div>
      </div>
    </div>
  )
}
